import { PARTNER_KEYS } from "../../utils/partner";

// Per-partner external links for V2 code — the same lookup shape as
// theme/partnerAssets.js, so V2 components never branch on the partner.
// URLs mirror the table inside the legacy components/Footer.jsx; keep the two
// in sync until every partner is on the V2 footer.
const DEFAULTS = {
  backToPartner: "https://meuhedetwow.onelink.me/XrAs?route=/sport",
};

const BY_PARTNER = {
  [PARTNER_KEYS.CLALIT]: {
    backToPartner: "https://onelink.to/clalit_active",
  },
  [PARTNER_KEYS.MEHUDET]: {
    backToPartner: "https://meuhedetwow.onelink.me/XrAs?route=/sport",
  },
  [PARTNER_KEYS.LEUMIT]: {
    backToPartner: "https://leumitfit.onelink.me/EY0x",
  },
  [PARTNER_KEYS.OVDIM_BARI]: {
    backToPartner: "https://ovdimbari.onelink.me/l3N5/4ju1o7by",
  },
  [PARTNER_KEYS.MAOFLAAMIT]: {
    backToPartner: "https://maof.onelink.me/cVce/gifgl8hw",
  },
};

export const getPartnerLink = (partner, name) => BY_PARTNER[partner]?.[name] ?? DEFAULTS[name];
